import type { ReactNode } from 'react'
import { FileDiff, MessagesSquare } from 'lucide-react'
import { TabsList, TabsTrigger } from '@/components/ui/Tabs'

// The switcher at the top of every review page (Top Down, By Month, Pricings):
// the discussion on one side, the numbers under review on the other, each
// with its count, GitHub pull-request style. `changeCount` is null when there
// is no published version to compare against; the chip is hidden then rather
// than showing a misleading 0. `aside` sits at the right end of the same row.
export default function ReviewTabsList({ commentCount, changeCount, aside }: {
  commentCount: number
  changeCount: number | null
  aside?: ReactNode
}) {
  return (
    <div className="mb-4 flex items-center justify-between gap-4">
      <TabsList variant="segmented">
        <TabsTrigger variant="segmented" value="conversation">
          <MessagesSquare className="h-4 w-4" aria-hidden />
          Conversation
          <TabCount count={commentCount} />
        </TabsTrigger>
        <TabsTrigger variant="segmented" value="changes">
          <FileDiff className="h-4 w-4" aria-hidden />
          Plan changes
          {changeCount != null && <TabCount count={changeCount} />}
        </TabsTrigger>
      </TabsList>
      {aside}
    </div>
  )
}

function TabCount({ count }: { count: number }) {
  return (
    <span className="inline-flex h-5 min-w-[1.25rem] items-center justify-center rounded-full bg-muted px-1.5 text-[11px] font-semibold tabular-nums text-foreground group-data-[state=active]:bg-primary/15 group-data-[state=active]:text-primary">
      {count}
    </span>
  )
}
